export default function(str) {
    const regExp = /<br\/>|<br>|<br \/>/g;
    if (!str) {
        return null;
    }
    return str.replace(regExp, ' ');
}
